<template>
  <section class="section section-subscribe">
    <div class="container">
      <div class="subscribe-header">
        <h1>确认订单</h1>
        <p>选择支付方式完成订阅</p>
      </div>

      <div class="subscribe-content">
        <div class="order-info">
          <h3>订单信息</h3>
          <div class="info-item">
            <span class="label">订阅方案：</span>
            <span class="value">{{ orderInfo.planName }}</span>
          </div>
          <div class="info-item">
            <span class="label">订阅周期：</span>
            <span class="value">{{ orderInfo.period }}</span>
          </div>
          <div class="info-item">
            <span class="label">订单金额：</span>
            <span class="price">¥{{ orderInfo.price }}</span>
          </div>
        </div>

        <div class="payment-methods">
          <h3>选择支付方式</h3>
          <div class="payment-list">
            <div 
              class="payment-item" 
              :class="{ 'active': selectedPayment === 'alipay' }"
              @click="selectPayment('alipay')"
            >
              <div class="payment-icon alipay-icon">
                <img src="/images/zfb.jpeg" alt="支付宝" class="payment-icon-img">
              </div>
              <div class="payment-info">
                <span class="payment-name">支付宝</span>
                <span class="payment-desc">推荐有支付宝账号的用户使用</span>
              </div>
              <div class="payment-check" v-if="selectedPayment === 'alipay'">✓</div>
            </div>

            <div 
              class="payment-item" 
              :class="{ 'active': selectedPayment === 'wechat' }"
              @click="selectPayment('wechat')"
            >
              <div class="payment-icon wechat-icon">
                <img src="/images/wxzf.jpg" alt="微信支付" class="payment-icon-img">
              </div>
              <div class="payment-info">
                <span class="payment-name">微信支付</span>
                <span class="payment-desc">推荐有微信账号的用户使用</span>
              </div>
              <div class="payment-check" v-if="selectedPayment === 'wechat'">✓</div>
            </div>

            <div 
              class="payment-item" 
              :class="{ 'active': selectedPayment === 'union' }"
              @click="selectPayment('union')"
            >
              <div class="payment-icon union-icon">
                <img src="/images/ysf.jpeg" alt="银联支付" class="payment-icon-img">
              </div>
              <div class="payment-info">
                <span class="payment-name">银联支付</span>
                <span class="payment-desc">支持所有银行卡</span>
              </div>
              <div class="payment-check" v-if="selectedPayment === 'union'">✓</div>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <button class="btn-back" @click="goBack">返回</button>
          <button class="btn-pay" @click="submitPayment" :disabled="!selectedPayment || isProcessing">
            {{ isProcessing ? '处理中...' : '确认支付' }}
          </button>
        </div>
      </div>

      <!-- 支付二维码弹窗 -->
      <div class="qr-modal" v-if="showQrModal">
        <div class="qr-content">
          <div class="qr-header">
            <h3>请使用{{ getPaymentName() }}扫码支付</h3>
            <button class="close-btn" @click="closeQrModal">×</button>
          </div>
          <div class="qr-body">
            <div class="qr-code" v-if="qrCodeUrl">
              <img :src="qrCodeUrl" alt="支付二维码">
            </div>
            <div class="qr-info">
              <p>应付金额：<strong>¥{{ orderInfo.price }}</strong></p>
              <p>订单号：{{ currentOrderNo }}</p>
              <p class="qr-tip">请在15分钟内完成支付</p>
            </div>
          </div>
          <div class="qr-footer">
            <button class="btn-refresh" @click="refreshQrCode">刷新二维码</button>
            <button class="btn-complete" @click="checkPaymentStatus">已完成支付</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Subscribe',
  data() {
    return {
      orderInfo: {
        planName: '',
        period: '',
        price: 0,
        planId: ''
      },
      selectedPayment: '',
      isProcessing: false,
      showQrModal: false,
      qrCodeUrl: '',
      currentOrderNo: '',
      checkPaymentTimer: null,
      userInfo: null
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    
    if (!this.userInfo.id) {
      this.$router.push('/login')
      return
    }
    
    this.orderInfo.planName = this.$route.query.plan || '月度会员'
    this.orderInfo.price = parseFloat(this.$route.query.price) || 0
    this.orderInfo.period = this.$route.query.period || '月'
    this.orderInfo.planId = this.$route.query.planId || 'monthly'
  },
  beforeDestroy() {
    if (this.checkPaymentTimer) {
      clearInterval(this.checkPaymentTimer)
    }
  },
  methods: {
    selectPayment(payment) {
      this.selectedPayment = payment
    },
    getPaymentName() {
      const paymentNames = {
        'alipay': '支付宝',
        'wechat': '微信支付',
        'union': '银联支付'
      }
      return paymentNames[this.selectedPayment] || ''
    },
    goBack() {
      this.$router.go(-1)
    },
    async submitPayment() {
      if (!this.selectedPayment) {
        this.$message.warning('请选择支付方式')
        return
      }

      this.isProcessing = true

      try {
        // 调用后端创建订单API
        const orderResponse = await axios.post('/api/orders', {
          user_id: this.userInfo.id,
          plan_id: this.orderInfo.planId,
          payment_method: this.selectedPayment
        })

        if (orderResponse.data.code === 200) {
          this.currentOrderNo = orderResponse.data.data.order_no
          
          // 显示二维码弹窗（模拟支付）
          this.showQrModal = true
          this.qrCodeUrl = this.generateMockQr()
          this.startPaymentCheck()
        } else {
          this.$message.error(orderResponse.data.message || '订单创建失败')
        }
      } catch (error) {
        console.error('支付提交失败:', error)
        this.$message.error('支付提交失败，请稍后重试')
      } finally {
        this.isProcessing = false
      }
    },
    generateMockQr() {
      return `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect width="200" height="200" fill="#fff"/><text x="100" y="100" text-anchor="middle" font-size="14" fill="#333">模拟支付</text><text x="100" y="120" text-anchor="middle" font-size="12" fill="#666">¥' + this.orderInfo.price + '</text></svg>')}`
    },
    closeQrModal() {
      this.showQrModal = false
      if (this.checkPaymentTimer) {
        clearInterval(this.checkPaymentTimer)
      }
    },
    refreshQrCode() {
      this.qrCodeUrl = this.generateMockQr()
    },
    startPaymentCheck() {
      // 轮询超时时间：15分钟
      const POLL_TIMEOUT = 15 * 60 * 1000
      const POLL_INTERVAL = 3000
      const startTime = Date.now()

      this.checkPaymentTimer = setInterval(async () => {
        // 检查是否超时
        if (Date.now() - startTime > POLL_TIMEOUT) {
          clearInterval(this.checkPaymentTimer)
          this.closeQrModal()
          this.$router.push({
            path: '/payment-failed',
            query: {
              order_no: this.currentOrderNo,
              amount: this.orderInfo.price,
              reason: '支付超时，请在15分钟内完成支付'
            }
          })
          return
        }

        try {
          const response = await axios.get(`/api/orders/${this.currentOrderNo}`)
          if (response.data.code === 200) {
            const order = response.data.data
            if (order.status === 'completed' || order.status === 'paid') {
              clearInterval(this.checkPaymentTimer)
              this.closeQrModal()
              this.$router.push({
                path: '/payment-success',
                query: {
                  order_no: this.currentOrderNo
                }
              })
            } else if (order.status === 'failed' || order.status === 'cancelled') {
              clearInterval(this.checkPaymentTimer)
              this.closeQrModal()
              this.$router.push({
                path: '/payment-failed',
                query: {
                  order_no: this.currentOrderNo,
                  amount: this.orderInfo.price,
                  reason: order.status === 'cancelled' ? '订单已取消' : '支付失败，请重试'
                }
              })
            }
          }
        } catch (error) {
          console.error('检查支付状态失败:', error)
        }
      }, POLL_INTERVAL)
    },
    async checkPaymentStatus() {
      try {
        const response = await axios.get(`/api/orders/${this.currentOrderNo}`)
        
        if (response.data.code === 200) {
          const order = response.data.data
          if (order.status === 'completed' || order.status === 'paid') {
            this.closeQrModal()
            this.$router.push({
              path: '/payment-success',
              query: {
                order_no: this.currentOrderNo
              }
            })
          } else if (order.status === 'failed' || order.status === 'cancelled') {
            this.closeQrModal()
            this.$router.push({
              path: '/payment-failed',
              query: {
                order_no: this.currentOrderNo,
                amount: this.orderInfo.price,
                reason: '支付失败，请重试'
              }
            })
          } else {
            this.$message.warning('订单仍在处理中，请稍候...')
          }
        } else {
          this.$message.error('获取订单信息失败')
        }
      } catch (error) {
        console.error('检查支付状态失败:', error)
        this.$message.error('检查支付状态失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.section-subscribe {
  padding: 120px 0 60px;
  background: #0d0f16;
  min-height: 100vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px;
}

.subscribe-header {
  text-align: center;
  margin-bottom: 40px;
}

.subscribe-header h1 {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
}

.subscribe-header p {
  font-size: 16px;
  color: #8892b0;
}

.subscribe-content {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 32px;
}

.order-info {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.order-info h3,
.payment-methods h3 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  color: #e6f1ff;
}

.info-item .label {
  color: #8892b0;
}

.info-item .price {
  font-size: 28px;
  font-weight: 700;
  color: #00e6ac;
}

.payment-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.payment-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 2px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-item:hover {
  border-color: rgba(0, 230, 172, 0.3);
  background: rgba(0, 230, 172, 0.05);
}

.payment-item.active {
  border-color: #00e6ac;
  background: rgba(0, 230, 172, 0.1);
}

.payment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  overflow: hidden;
  flex-shrink: 0;
}

.payment-icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.payment-icon svg {
  width: 32px;
  height: 32px;
}

.payment-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payment-name {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.payment-desc {
  font-size: 14px;
  color: #8892b0;
}

.payment-check {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #00e6ac;
  color: #0a192f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  gap: 16px;
  margin-top: 32px;
}

.btn-back,
.btn-pay {
  flex: 1;
  padding: 16px 24px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back {
  background: transparent;
  color: #8892b0;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.btn-pay {
  background: linear-gradient(135deg, #00e6ac, #00c292);
  color: #0a192f;
  border: none;
}

.btn-pay:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 230, 172, 0.3);
}

.btn-pay:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 二维码弹窗 */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.qr-content {
  background: #1a1e2d;
  border-radius: 16px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
}

.qr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.qr-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-body {
  text-align: center;
}

.qr-code {
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  display: inline-block;
  margin-bottom: 20px;
}

.qr-code img {
  width: 200px;
  height: 200px;
}

.qr-info p {
  color: #e6f1ff;
  margin: 8px 0;
  font-size: 14px;
}

.qr-info strong {
  color: #00e6ac;
  font-size: 20px;
}

.qr-tip {
  color: #ff6b6b !important;
  font-size: 12px !important;
}

.qr-footer {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-refresh,
.btn-complete {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-refresh {
  background: transparent;
  color: #8892b0;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-refresh:hover {
  background: rgba(255, 255, 255, 0.05);
}

.btn-complete {
  background: #00e6ac;
  color: #0a192f;
  border: none;
}

.btn-complete:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 230, 172, 0.3);
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
  }
}
</style>
